import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { Task } from 'js-sdk/src/types/Tasks';

export type TasksSliceState = {
  /**
   * Tasks created (or mutated) in this session, keyed by their source
   * `message_id`. Lets a message row render its task card immediately.
   *
   * NOTE: this is session-local only. There is no task-svc endpoint yet to
   * hydrate existing tasks per message on load — see `useMessageTask` and the
   * PR "Backend dependencies" section.
   */
  linkedTasksByMessageId: Record<string, Task>;
};

const initialState: TasksSliceState = {
  linkedTasksByMessageId: {},
};

const tasksSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    setLinkedTask: (state, action: PayloadAction<Task>) => {
      const task = action.payload;
      if (task.source_type === 'message' && task.source_ref?.message_id) {
        state.linkedTasksByMessageId[task.source_ref.message_id] = task;
      }
    },
    setTasks: (state, action: PayloadAction<Task[]>) => {
      for (const task of action.payload) {
        if (task.source_type === 'message' && task.source_ref?.message_id) {
          state.linkedTasksByMessageId[task.source_ref.message_id] = task;
        }
      }
    },
    clearLinkedTask: (state, action: PayloadAction<{ messageId: string }>) => {
      delete state.linkedTasksByMessageId[action.payload.messageId];
    },
  },
});

export { tasksSlice };
